module.exports = __webpack_public_path__ + "static/1193433604.d1fb1742.jpg";